<div class="page-header">
	<h1 class="page-title">Partner List</h1>
	<div class="page-actions">
		<a [routerLink]="['/partner','new']" class="btn btn-outline-primary">New Partner</a>
	</div>
</div>
<div class="row mt-3">
	<div class="col">
		<app-table
			[downloadHeading]="'Partner List'"
			[downloadName]="'partner_list'"
			[data]="results"
			[headerClass]="'table-info'"
			[columns]="columnRef"
			[filters]="[]"
			[loading]="loading"
			(onUpdateRequired)="doFetchResults($event)"
			(onRowClick)="open($event)"
			>
			<ng-template #logo let-row="row">
				<td *ngIf="!row.image">
					-
				</td>
				<td *ngIf="row.image">
					<img [src]="getLogoUrl(row)" style="height: 3em;">
				</td>
			</ng-template>
			<ng-template #contact let-row="row">
				<td>
					{{row.contacts[0]?.fullName??'No contact'}}
				</td>
			</ng-template>
		</app-table>
	</div>
</div>
